/* eslint-disable no-console */
import { APIResponse, ResponseMeta } from '@models/Common'
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { camelizeObject, decamelizeObject } from './interceptors/camelize'
import environment from 'config/environment'
import i18next from 'i18next'

// Automatically decamelize request data for every request.
// eslint-disable-next-line @typescript-eslint/require-await
export const requestInterceptor = async (request: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  if (environment.isDev) {
    const { url, data, method, params } = request
    console.log({ requestUrl: url, data, requestMethod: method, params })
  }

  const { data, headers } = request

  return {
    ...request,
    data,
    headers: {
      ...headers,
      'Accept-Language': i18next.language,
    },
  }
}

export function responseInterceptor(response: AxiosResponse) {
  if (import.meta.env.VITE_ENV === 'dev') {
    console.log({ response: response })
  }
  const { data, status, statusText } = response

  const camelizedData = camelizeObject(data ?? {})

  return {
    ...response,
    data: camelizedData,
    meta: undefined,
    status,
    statusText,
  }
}

const logErrorForDev = (error: AxiosError): void => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const { data, status, headers } = error.response
    console.log({ data, status, headers })
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log({ requestError: error.request })
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message)
  }
  console.log(error.config)
}

const formatError = (error: AxiosError): ResponseMeta => {
  // TODO: Backend error formatting is inconsistent
  return { status_code: error?.code ?? '500', message: error?.response?.data?.detail ?? 'Unknown error' }
}

export const errorInterceptor = (error: AxiosError): Promise<ResponseMeta> => {
  if (import.meta.env.VITE_ENV === 'dev') {
    logErrorForDev(error)
  }
  // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
  return Promise.reject(formatError(error))
}
